import { useMutation } from '@tanstack/react-query'
import { login } from '@/services/api/auth'
import { useAuthStore } from '@/store/authStore'

const LOGIN_MUTATION_KEY = ['mutation', 'auth', 'login'] as const

interface LoginVars {
  login: string
  password: string
}

/**
 * Logs in and applies the resulting session (user/token/refreshToken) to
 * `authStore`. Not offline-replayable — auth must never queue while offline.
 * Bad credentials (401) and the login throttle (429) are shown inline by
 * `LoginPage`, so they opt out of the global toast/report.
 */
export function useLogin() {
  const setAuth = useAuthStore((s) => s.setAuth)

  return useMutation({
    mutationKey: LOGIN_MUTATION_KEY,
    mutationFn: ({ login: loginValue, password }: LoginVars) => login(loginValue, password),
    meta: { inlineErrorStatuses: [401, 429] },
    onSuccess: (data) => {
      setAuth(data.user, data.token, data.refreshToken)
    },
  })
}
